export default "__VITE_ASSET__LOYrwNlJ__"